import { Link } from 'react-router-dom';
import Arrow from './Arrow';
import { trackEvent } from '../lib/analytics';

export default function Nav() {
  return (
    <nav className="nav">
      <div className="nav-in">
        <Link className="lockup" to="/">
          <span className="mk">
            <span className="b">[</span>
            <span className="e">=</span>
            <span className="b">]</span>
          </span>
          <span className="wm">
            rcrt
            <span className="caret" />
          </span>
        </Link>
        <div className="nav-links">
          <Link className="lnk" to="/how-it-works" onClick={() => trackEvent('nav_click', { target: 'how' })}>how it works</Link>
          <Link className="lnk" to="/live-demo" onClick={() => trackEvent('nav_click', { target: 'demo' })}>live demo</Link>
          <Link className="lnk" to="/calculator" onClick={() => trackEvent('nav_click', { target: 'calculator' })}>calculator</Link>
          <Link className="lnk" to="/whats-shipping" onClick={() => trackEvent('nav_click', { target: 'shipping' })}>what's shipping</Link>
          <Link className="lnk" to="/sdk" onClick={() => trackEvent('nav_click', { target: 'sdk' })}>sdk</Link>
          <a
            className="btn btn-primary"
            href="https://calendar.app.google/QJ59uMjvpv5EokCo7"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackEvent('cta_click', { cta: 'book_session', location: 'nav' })}
          >
            Book a session
            <Arrow />
          </a>
        </div>
      </div>
    </nav>
  );
}
